import { useParams } from 'react-router';
import { IAgent } from '@/types';
import { getUrl } from '@/utils/api';

function useAgent(id?: string) {
  const { agentId } = useParams<{ agentId: string }>();
  const query = getUrl(`v1/agents/${id ? id : agentId}`);
  return {
    ...query,
    data: query.data as IAgent,
  };
}

export default useAgent;
